import React, { useCallback } from "react";
import ReactDOM from "react-dom";
import { unmountComponentAtNode } from "react-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "../../../../../i18n";
import OctopartApp from "../../../../../octopart-app/App";

function Purchase({ result }) {
  const { t } = useTranslation();
  const quantity = +result["buyonline"].raw;

  const onPurchage = useCallback(() => {
    const modelName = result["model_name"].raw;
    window.omModelNumber = modelName;

    const id = 'j-modal-template';
    const element = document.getElementById(id);
    element.classList.add("is-show");

    setTimeout(() => {
      const sellerDomElement = document.getElementById('seller-list');
      ReactDOM.render(<I18nextProvider i18n={i18n}><OctopartApp /></I18nextProvider>, sellerDomElement);
      document.querySelector('.c-modal__button--close').addEventListener('click', function() {
        const id = 'j-modal-template';
        unmountComponentAtNode(sellerDomElement);
        const element = document.getElementById(id);
        element.classList.remove("is-show");
      })
    }, 200);
  }, []);

  return (
    <td width="8%">
      {quantity > 0 ? (
        <button className="c-button--ec" onClick={onPurchage}>
          {t("Buy Online")}
        </button>
      ) : null}
    </td>
  );
}
export default Purchase;